import Vue from 'vue'
import Vuex from 'vuex'
import {doFetch, ApiError, ApiNotAvailableError, ApiAuthorizationError } from '../lib/api' 
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    account: null,

    auth_error_count: 0,
    dirty: false,
    error: null,
    errors: null,
    global_error: null,
    in_process: 0,
    jwt: null,
    message: null,
    realm_id: null,
    user: null,

    api_user: null,
    api_secret: null,
    api_integration_code: null,
  },
  mutations: {
    clearMessageAndErrors(state){
      state.global_error = null;
      state.message = null;
      state.error = null;
      state.errors = null;
    },
    incrementAuthErrorCount(state){
      if(state.auth_error_count === null) state.auth_error_count=0;
      state.auth_error_count++;
    },
    incrementInProcess(state){
      state.in_process++;
    },
    decrementInProcess(state){
      state.in_process--;
    },
    setAccount(state, account) {
      state.account = account;
    },
    setAuthErrorCount(state, auth_error_count){
      state.auth_error_count = auth_error_count;
    },
    setDirty(state, dirty){
      state.dirty = dirty;
    },
    setError(state, error){
      state.error = error;
    },
    setErrors(state, errors){
      state.errors = errors;
    },
    setGlobalError(state, global_error){
      state.global_error = global_error;
    },
    setJwt(state, jwt) {
      state.jwt = jwt;
    },
    setMessage(state, message){
      state.message = message;
    },
    setRealmId(state, realm_id) {
      state.realm_id = realm_id;
    },
    setUser(state, user) {
      state.user = user;
    },
    setApiIntegrationCode(state, api_integration_code) {
      state.api_integration_code = api_integration_code;
    },
    setApiSecret(state, api_secret) {
      state.api_secret = api_secret;
    },
    setApiUser(state, api_user) {
      state.api_user = api_user;
    },
   
  },
  getters: {
    account: state => state.account,
    
    auth_error_count: state => state.auth_error_count,
    busy: state => state.in_process>0,
    dirty: state => state.dirty,
    error: state => state.error,
    errors: state => state.errors,
    global_error: state => state.global_error,
    has_error: state => state.error ? true : false,
    has_global_error: state => state.global_error ? true : false,
    has_message: state => state.message ? true : false,
    in_process: state => state.in_process,
    is_admin: state => state.user && state.user.roles && state.user.roles.includes("admin"),
    is_client: state => state.user && state.user.roles && state.user.roles.includes("client"),
    jwt: state => state.jwt,
    message: state => state.message,
    realm_id: state => state.realm_id,
    user: state => state.user,

    api_integration_code: state => state.api_integration_code,
    api_secret: state => state.api_secret,
    api_user: state => state.api_user,
  },
  actions: {
    async apiGet({commit}, fetchOptions) {
      fetchOptions.method = 'GET';
      try{
        commit('clearMessageAndErrors');
        commit('incrementInProcess');
        let data = await doFetch(this.state.jwt, fetchOptions);
        if(data && data.message) commit('setMessage', data.message);
        return data;
      }catch(ex){
        if(ex instanceof ApiNotAvailableError){ 
          commit('setGlobalError', ex.message);
        } else if(ex instanceof ApiAuthorizationError){ 
          commit('incrementAuthErrorCount');
        } else if(ex instanceof ApiError){
          if(ex.data && ex.data.message) commit('setMessage', ex.data.message);
          if(ex.data && ex.data.error) commit('setError', ex.data.error);
          if(ex.data && ex.data.errors) commit('setErrors', ex.data.errors);
        } else {
          commit('setError', "Lookup error.");
          console.error(ex);
        }
      } finally {
        commit('decrementInProcess')
      }
      
    },
    async apiPost({commit}, fetchOptions) {
      fetchOptions.method = 'POST';
      try{
        commit('clearMessageAndErrors');
        commit('incrementInProcess');
        let data = await doFetch(this.state.jwt, fetchOptions);
        if(data && data.message) commit('setMessage', data.message);
        return data;
      }catch(ex){
        if(ex instanceof ApiNotAvailableError){ 
          commit('setGlobalError', ex.message);
        } else if(ex instanceof ApiAuthorizationError){ 
          commit('incrementAuthErrorCount');
        } else if(ex instanceof ApiError){
          console.error(ex);
          console.error(ex.data);
          if(ex.data){
            if(ex.data.message)  commit('setError', ex.data.message);
            if(ex.data.error) console.error(ex.data.error);
            if(ex.data.errors) commit('setErrors', ex.data.errors);
          } 
        } else {
          commit('setError', "Processing error.");
          console.error(ex);
        }
      } finally {
        commit('decrementInProcess')
      }
    },
    async apiPut({commit}, fetchOptions) {
      fetchOptions.method = 'PUT';
      try{
        commit('clearMessageAndErrors');
        commit('incrementInProcess');
        let data = await doFetch(this.state.jwt, fetchOptions);
        if(data && data.message) commit('setMessage', data.message);
        return data;
      }catch(ex){
        if(ex instanceof ApiNotAvailableError){ 
          commit('setGlobalError', ex.message);
        } else if(ex instanceof ApiAuthorizationError){ 
          commit('incrementAuthErrorCount');
        } else if(ex instanceof ApiError){
          if(ex.data){
            if(ex.data.message)  commit('setError', ex.data.message);
            if(ex.data.error) console.error(ex.data.error);
            if(ex.data.errors) commit('setErrors', ex.data.errors);
          }
        } else {
          commit('setError', "Update error.");
          console.error(ex);
        }
      } finally {
        commit('decrementInProcess')
      }
    },
    async apiDelete({commit}, fetchOptions) {
      fetchOptions.method = 'DELETE';
      try{
        commit('clearMessageAndErrors');
        commit('incrementInProcess');
        let data = await doFetch(this.state.jwt, fetchOptions);
        if(data && data.message) commit('setMessage', data.message);
        return data;
      }catch(ex){
        if(ex instanceof ApiNotAvailableError){ 
          commit('setGlobalError', ex.message);
        } else if(ex instanceof ApiAuthorizationError){ 
          commit('incrementAuthErrorCount');
        } else if(ex instanceof ApiError){
          if(ex.data){
            if(ex.data.message)  commit('setError', ex.data.message);
            if(ex.data.error) console.error(ex.data.error);
            if(ex.data.errors) commit('setErrors', ex.data.errors);
          }
        } else {
          commit('setError', "Deletion error.");
          console.error(ex);
        }
      } finally {
        commit('decrementInProcess')
      }
    },

    flashMessage({commit}, message){
      commit('setMessage', message);
      setTimeout(()=>{
        commit('setMessage', null);
        commit('setDirty', false);
      }, 3000)
    },

    //
    // API actions
    //
    async loadAccount({dispatch, commit}, account_id) {
      if(!account_id) account_id = this.state.account_id;
      let response = await dispatch('apiGet', {url: `/api/accounts/${account_id}`}); 
      commit('setAccount', response);
    },
    async saveAccount({dispatch, commit}, account) {
      let response = await dispatch('apiPost', {url: `/api/accounts/${account.id}`, body: account});
      commit('setAccount', response);
      dispatch('flashMessage', "Account saved.");
    },

  },
  modules: {
  }
})

